<template>
	<div class="product-swiper">
		<div class="swiper-container gallery-top">
			<div class="swiper-wrapper">
				<div
					class="swiper-slide lazyload"
					data-sizes="auto"
					v-for="(image, index) in images"
					:key="index"
					@click="toggleModal(image)"
				>
					<v-image :src="image"></v-image>
				</div>
			</div>
		</div>
		<div class="swiper-container gallery-thumbs">
			<div class="swiper-wrapper">
				<div
					class="swiper-slide lazyload"
					data-sizes="auto"
					v-for="(image, index) in images"
					:key="index"
					:data-bgset="image"
				></div>
			</div>
		</div>
		<v-lightbox
			:openModal="openModal"
			:src="activeSlide"
			@close="toggleModal"
		></v-lightbox>
		<!-- <v-tag v-bind="{ type, content }"></v-tag> -->

		<!-- If we need navigation buttons -->
		<div class="swiper-button-prev"></div>
		<div class="swiper-button-next"></div>
	</div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";
import vLightbox from "./lightbox.vue";
import vImage from "./responsive-image.vue";
// import vTag from "./tag.vue";

export default {
	props: {
		images: { required: true },
		type: { required: true, type: String },
		content: { required: true, type: String }
	},
	components: {
		vLightbox,
		vImage,
		// vTag
	},
	data() {
		return {
			openModal: false,
			activeSlide: ""
		};
	},
	methods: {
		toggleModal(image) {
			this.activeSlide = image;
			this.openModal = !this.openModal;
		}
	},
	mounted() {
		const galleryThumbs = new Swiper(".gallery-thumbs", {
			spaceBetween: 10,
			slidesPerView: 6.3,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			}
		});
		// init swiper
		const galleryTop = new Swiper(".gallery-top", {
			spaceBetween: 10,
			thumbs: {
				swiper: galleryThumbs
			}
		});
	}
};
</script>

<style lang="scss" scoped>
.product-swiper {
	width: 45%;
	position: relative;

	@include res(tab-p) {
		width: 85%;
	}

	@include res(mobile) {
		width: 100%;
	}

	.swiper-button-prev,
	.swiper-button-next {
		width: 40px;
		height: 30px;
		background-size: contain;
		outline: none;
		bottom: 5%;
		top: unset;
	}

	.swiper-button {
		&-prev {
			transform: rotate(180deg);
			background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='25px' height='45px' viewBox='0 0 25 45' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EUI/Next%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Module/Funiture' transform='translate(-1372.000000, -371.000000)' stroke='%23969BA5'%3E%3Cg id='UI/Next' transform='translate(1373.000000, 372.000000)'%3E%3Cg id='Icons/dropdown_arrow' transform='translate(11.000000, 21.500000) rotate(-90.000000) translate(-11.000000, -21.500000) translate(-10.000000, 11.000000)'%3E%3Cpolyline id='Path-2' stroke-width='3' points='0 0.0245707891 20.9877074 21 42 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
			left: -8%;
		}
		&-next {
			background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='25px' height='45px' viewBox='0 0 25 45' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com --%3E%3Ctitle%3EUI/Next%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Module/Funiture' transform='translate(-1372.000000, -371.000000)' stroke='%23969BA5'%3E%3Cg id='UI/Next' transform='translate(1373.000000, 372.000000)'%3E%3Cg id='Icons/dropdown_arrow' transform='translate(11.000000, 21.500000) rotate(-90.000000) translate(-11.000000, -21.500000) translate(-10.000000, 11.000000)'%3E%3Cpolyline id='Path-2' stroke-width='3' points='0 0.0245707891 20.9877074 21 42 0'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
			right: -8%;
		}
	}
}

.gallery-top {
	width: 100%;
	margin-left: auto;
	margin-right: auto;

	.swiper-slide {
		width: 100%;
		background-size: cover;
		background-position: center;
		padding-top: 100%;

		img {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			cursor: zoom-in;
		}
	}
}

.gallery-thumbs {
	padding: 10px 0;

	.swiper-slide {
		padding-top: 15%;
		background-size: cover;
		background-position: center;

		@include res(mobile) {
			height: 35px;
		}
	}
}
</style>
